import { AppState } from '../../app-state';

export const selectAnnotationReviewIsComplete = (
  state: AppState,
): boolean | null => state.annotationReview.completed;
